@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.containerWithImage {
    display: grid;
    grid-template-columns: 1fr 1fr;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }
}

.containerWithoutImage {
    display: block;
    padding-left: 3vw;
}

.image {
    grid-column: 1/2;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
    object-position: bottom left;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        display: none;
    }
}

.accordions {
    grid-column: 2/3;
    padding-right: 3vw;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1/2;
        padding: 0 8vw;
    }
}

.trigger {
    align-items: flex-start;
    background-color: transparent;
    border: none;
    border-top: 1px solid var(--text-color);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding: 1rem 0;
    text-align: left;
    width: 100%;

    &::after {
        background-color: var(--text-color);
        content: "";
        display: block;
        height: 25px;
        margin-right: 0.25rem;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z'/%3E%3C/svg%3E");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 20px 20px;
        min-width: 25px;
    }

    &[aria-expanded="true"] {
        &::after {
            mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z'/%3E%3C/svg%3E");
        }
    }

    & p {
        // Override default .rich-text p styling
        margin: 0;
    }
}

.content {
    & ul {
        margin-top: 0;
    }

    & li {
        font-size: 1rem;
    }
}
